import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import {
  compact,
  isEqual,
} from 'lodash';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';

import { getDeliveryScheduleStatus, toISO } from 'helpers/utils';

const styles = () => ({
  clickedButton: {
    backgroundColor: 'white',
    borderRadius: 5,
    border: '1px solid gray',
  },
  clickedLabel: {
    color: 'gray',
    fontSize: 12,
  },
  normalButton: {
    backgroundColor: 'white',
    borderRadius: 5,
    border: '1px solid green',
  },
  normalLabel: {
    color: 'green',
    fontSize: 12,
  },
});

class DeliverySchedule extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    deliverySchedule: PropTypes.arrayOf(PropTypes.shape({})),
    readOnly: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
  };

  static defaultProps = {
    deliverySchedule: [],
    readOnly: false,
  };

  state = {
    date: new Date(),
    deliverySchedule: this.props.deliverySchedule || [],
  };

  componentWillReceiveProps(newProps) {
    if (!isEqual(this.props.deliverySchedule, newProps.deliverySchedule)) {
      this.setState({ deliverySchedule: newProps.deliverySchedule || [] }, this.up);
    }
  }

  onAddDeliverySchedule = (newSchedule) => {
    const deliverySchedule = this.state.deliverySchedule.filter(schedule => typeof schedule === 'object');
    const { type, day, year, month, date, enabled } = newSchedule;
    if (type === 'day') {
      const newDeliverySchedule = deliverySchedule.filter(schedule => (
        schedule.day !== day
      ));
      if (enabled) {
        newDeliverySchedule.push(newSchedule);
      }
      this.setState({ deliverySchedule: newDeliverySchedule }, this.update);
      return;
    }
    const newDeliverySchedule = deliverySchedule.filter(schedule => (
      schedule.type !== 'date' ||
      schedule.date !== date ||
      schedule.year !== year ||
      schedule.month !== month
    ));
    newDeliverySchedule.push(newSchedule);
    this.setState({ deliverySchedule: newDeliverySchedule }, this.update);
  };

  onChange = date => this.setState({ date });

  update = () => {
    this.props.update(this.state.deliverySchedule);
  };

  render() {
    const { classes, formatMessage, readOnly } = this.props;
    const { date, deliverySchedule } = this.state;

    const mDate = moment(date);

    const { enabled } = getDeliveryScheduleStatus(deliverySchedule, date);
    return (
      <div className={`form-field delivery-schedule ${readOnly ? 'loading-enabled loading' : ''}`}>
        <h4>{formatMessage('Delivery or Pick-Up Schedule')}</h4>
        <div className="calendar">
          <Calendar
            calendarType="US"
            onClickDay={this.onChange}
            tileClassName={({ date, view }) => {
              if (view !== 'month') return '';
              const { old, now, enabled } = getDeliveryScheduleStatus(deliverySchedule, date);
              const className = compact([
                'date',
                toISO(date) === toISO(this.state.date) && 'active',
                old && 'old disabled',
                now && 'now',
                enabled && 'select',
              ]).join(' ');
              return className;
            }}
            tileDisabled={({ date, view }) => {
              if (view !== 'month') return false;
              const { old } = getDeliveryScheduleStatus(deliverySchedule, date);
              return old;
            }}
            value={this.state.date}
          />
          <div className="button-group">
            <Button
              classes={{
                label: enabled ? classes.clickedLabel : classes.normalLabel,
                root: enabled ? classes.clickedButton : classes.normalButton,
              }}
              onClick={() => {
                this.onAddDeliverySchedule({
                  type: 'day',
                  enabled: !enabled,
                  year: date.getFullYear(),
                  month: date.getMonth(),
                  date: date.getDate(),
                  day: date.getDay(),
                  value: date,
                });
              }}
              size="small"
              variant={enabled ? 'contained' : 'outlined'}
            >
              {`EVERY ${mDate.format('ddd')}`}&nbsp;{enabled ? <Clear /> : <Done />}
            </Button>
            {/* <Button
              color="secondary"
              onClick={() => this.onAddDeliverySchedule(`n-d-${date.getDay()}`)}
              size="small"
              variant={deliverySchedule.indexOf(`n-d-${date.getDay()}`) === -1
                ? 'outlined' : 'contained'}
            >
              {mDate.format('ddd')}&nbsp;<Clear />
            </Button> */}
            <Button
              classes={{
                label: enabled ? classes.clickedLabel : classes.normalLabel,
                root: enabled ? classes.clickedButton : classes.normalButton,
              }}
              onClick={() => {
                this.onAddDeliverySchedule({
                  type: 'date',
                  enabled: !enabled,
                  year: date.getFullYear(),
                  month: date.getMonth(),
                  date: date.getDate(),
                  day: date.getDay(),
                  value: date,
                });
              }}
              size="small"
              variant={enabled ? 'contained' : 'outlined'}
            >
              {mDate.format('D MMM')}&nbsp;{enabled ? <Clear /> : <Done />}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DeliverySchedule);
